import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterPartnersProducts from 'views/products/partners-tipoproducto/filter'; // Importing filter component for partners products
import TablePartnersProducts from 'views/products/partners-tipoproducto/table'; // Importing table component for partners products
import DetailsPartnersProducts from 'views/products/partners-tipoproducto/details'; // Importing details component for partners products
import RecordPartnersProducts from 'views/products/partners-tipoproducto/record'; // Importing record component for partners products
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PartnersTypeProductView class extends JetView to create a view for managing partner product types.
 */
export default class PartnersTypeProductView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const right = {
            // Right section configuration
            type: 'wide',
            rows: [
                PlayersView, // Players view component
                DetailsPartnersProducts, // Details view component
                RecordPartnersProducts, // Record view component
            ],
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index
                            var last = first + size - 1; // Last item index
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Reference to the data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Tipo Producto Partner',
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Tipo Producto Partner',
                                    ignore: { rating: true }, // Ignore rating column
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        // Trigger export event
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Tipo Producto Partner',
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Tipo Producto Partner',
                                        autowidth: true, // Auto width for PDF
                                        ignore: { rating: true }, // Ignore rating column
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };
        const left = {
            // Left section configuration
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply theme
                    elements: [
                        { view: 'label', label: _('Tipo Producto Partner') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                FilterPartnersProducts, // Filter component
                TablePartnersProducts, // Table component
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left section
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check screen width
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the export dropdown for small screens
                $$('pagerA').define('group', 1); // Define pager grouping
            }
        });
    }
}

// FILE DOCUMENTED
